import Container from '@/components/Container';

const KnowledgeBaseCardSkeleton = () => (
  <div className="flex flex-col gap-sh-16 rounded-sh-16 border border-teal-accent bg-light-green p-sh-16 md:flex-row md:gap-sh-25">
    <div className="h-[200px] w-full animate-pulse rounded-t-sh-16 bg-gray-200 md:h-[220px] md:w-[359px] md:rounded-sh-16" />
    <div className="flex flex-1 flex-col gap-sh-16 pt-0 md:pt-sh-16">
      <div className="h-7 w-3/4 animate-pulse rounded bg-gray-200" />
      <div className="h-6 w-20 animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-full animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-2/3 animate-pulse rounded bg-gray-200" />
      <div className="h-4 w-24 animate-pulse rounded bg-gray-200" />
    </div>
  </div>
);

const KnowledgeBaseSkeleton = () => (
  <>
    <div className="w-full bg-light-green py-sh-60">
      <Container>
        <div className="col-span-12">
          <div className="my-[12px] h-9 w-64 animate-pulse rounded bg-gray-200" />
          <div className="mt-2 h-4 w-full max-w-xl animate-pulse rounded bg-gray-200" />
        </div>
      </Container>
    </div>
    <Container className="mt-sh-60 min-h-40">
      <div className="col-span-12">
        <div className="mb-sh-60">
          <div className="flex justify-start gap-6">
            <div className="h-8 w-20 animate-pulse rounded bg-gray-200" />
            <div className="h-8 w-24 animate-pulse rounded bg-gray-200" />
            <div className="h-8 w-16 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="mt-3 flex flex-wrap items-center gap-2">
            <div className="h-5 w-24 animate-pulse rounded bg-gray-200" />
            <div className="h-9 w-28 animate-pulse rounded-lg bg-gray-200" />
            <div className="h-9 w-32 animate-pulse rounded-lg bg-gray-200" />
            <div className="h-9 w-24 animate-pulse rounded-lg bg-gray-200" />
          </div>
        </div>
        <div className="my-[20px] h-8 w-48 animate-pulse rounded bg-gray-200" />
        <div className="mb-sh-30 flex flex-col gap-sh-30">
          <KnowledgeBaseCardSkeleton />
          <KnowledgeBaseCardSkeleton />
          <KnowledgeBaseCardSkeleton />
        </div>
        <div className="mt-sh-30 flex w-full items-center justify-center">
          <div className="h-10 w-28 animate-pulse rounded bg-gray-200" />
        </div>
      </div>
    </Container>
  </>
);

export default KnowledgeBaseSkeleton;
